import { CheckCircle2 } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import { aboutPageData } from "../../data/aboutData";

function AboutTrustSection() {
  const { trustPoints, trustSnapshot } = aboutPageData;

  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <div className="grid gap-7 lg:grid-cols-[0.88fr_1.12fr] lg:items-start">
          <div className="signature-card rounded-[1.8rem] p-6 md:p-8">
            <SectionHeading
              center={false}
              kicker="Why Families Trust Us"
              title="Guidance That Feels Personal and Dependable"
              description="Students receive strategic direction and families receive transparent communication at every stage."
            />

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3 lg:grid-cols-1">
              {trustSnapshot.map((item) => (
                <div key={item.label} className="rounded-xl bg-sky-glow/80 px-4 py-3">
                  <p className="text-2xl font-semibold text-midnight-navy">{item.value}</p>
                  <p className="text-xs uppercase tracking-[0.08em] text-slate-text/70">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            {trustPoints.map((point) => (
              <article
                key={point.title}
                className="signature-card signature-card-interactive rounded-2xl p-5"
              >
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-lg bg-sky-glow text-royal-blue">
                    <CheckCircle2 className="h-4.5 w-4.5" aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="text-lg text-midnight-navy">{point.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-slate-text/85">{point.text}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </MotionSection>
  );
}

export default AboutTrustSection;
